module.exports = __webpack_public_path__ + "static/media/Plus.af54acc9.svg";